import { HomePage } from "../HomePage";
import { EmailLink, StyledLink } from "./Links";

export const TexasLandingPage: React.FC = () => (
  <HomePage
    voucherLandingContent={{
      heroSubtitle: "Practice Smarter, Master Faster",
      heroBody: (
        <p>
          Great news&mdash;DeltaMath for Home is now an approved Texas PDSES
          vendor, helping parents support all learners with differentiated,
          adaptive math instruction! Empower students at home with personalized
          lessons that meet learning goals, build confidence, and accelerate
          progress.
        </p>
      ),
      cta: "Request a Quote",
      instructionsSubtitle:
        "To purchase DeltaMath for Home with your Texas PDSES funds, please follow the instructions below.",
      instructionsBody: (
        <>
          <ol className="flex list-decimal flex-col gap-1 pl-6">
            <li>
              Send an email with the following information to{" "}
              <EmailLink subject="PDSES ClassWallet Order" />:
              <ul className="flex list-disc flex-col gap-1 py-1 pl-6">
                <li>Subject Line: &ldquo;PDSES ClassWallet Order&rdquo;</li>
                <li>Parent First & Last Name</li>
                <li>
                  Parent Email Address (to be used for tracking, questions,
                  etc.)
                </li>
                <li>Parent Billing Address</li>
              </ul>
            </li>
            <li>
              Check your email to receive your quote within 1 business day
            </li>
            <li>
              Watch this short video to see how to easily upload your quote to
              ClassWallet.{" "}
              <StyledLink
                to="https://www.youtube.com/watch?v=vt0oLysesB4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Watch Now!
              </StyledLink>
            </li>
            <li>
              Keep an eye out for communication from DeltaMath for Home, on next
              steps to opening your account
            </li>
          </ol>
          <p>
            For assistance with an order or the status of an order, please email{" "}
            <EmailLink />.
          </p>
        </>
      ),
    }}
  />
);
